import React from 'react';
import classNames from 'classnames';
import { ObjectValues, XOR } from 'types';
import { SIZE, Size } from 'models/Size';

import './Counter.styles.scss';

export const COUNTER_VARIANTS = {
  ORANGE: 'orange',
  SILVER: 'silver',
  GREY: 'grey',
  PRIMARY: 'primary',
} as const;

type CounterVariant = ObjectValues<typeof COUNTER_VARIANTS>;

type CounterProps = {
  className?: string;
  size?: Size;
  variant?: CounterVariant;
  isPositionAbsolute?: boolean;
} & XOR<{ count: number; displayEmptyValue?: boolean }, { onlyDot: boolean }>;

const Counter: React.FC<CounterProps> = (props) => {
  const {
    children,
    className,
    count,
    onlyDot,
    size = SIZE.BIG,
    variant = COUNTER_VARIANTS.ORANGE,
    isPositionAbsolute = false,
    displayEmptyValue = false,
  } = props;

  if (!count && !displayEmptyValue && !onlyDot) return null;

  const classes = classNames(
    'counter',
    variant,
    `counter--${size}`,
    {
      absolute: isPositionAbsolute,
    },
    className,
  );

  return <span className={classes}>{children || count}</span>;
};

export default Counter;
